import { CircularProgress, colors } from '@material-ui/core';
import { useState } from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';
import Chart from 'react-google-charts';
import { useHistory } from 'react-router';
import { decimalFix } from '../../components/dashboard/portfolios/utils';
import enUs from '../../lang/en-us';

interface PieChartProps {
    data: any;
    title: string;
    totalValue: number;
}

export const DEFAULT_CHART_COLORS = [
    '#3366CC',
    '#DC3912',
    '#FF9900',
    '#109618',
    '#990099',
    '#0099C6',
    '#DD4477',
    '#3B3EAC',
    '#66AA00',
    '#B82E2E',
    '#316395',
    '#994499',
    '#22AA99',
    '#AAAA11',
    '#6633CC',
    '#E67300',
    '#8B0707',
    '#329262',
    '#5574A6',
    '#3B3EAC',
];

const pieOptions = {
    title: '',
    titleTextStyle: { color: '#fff', marginLeft: 100 },
    // Just add this option
    is3D: true,
    color: 'white',
    backgroundColor: '',
    fontSize: 12,
    chartArea: { width: '100%', height: '80%' },
    legend: 'none',
    focusTarget: 'category',
    role: 'tooltip',
    tooltip: { textStyle: { fontName: 'Montserrat-SemiBold' }, showColorCode: true },
};

export function PieChart({ totalValue = 0, ...props }: PieChartProps) {
    const [loadLegends, setLoad] = useState<boolean>(false);
    const history = useHistory();
    return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            {!(loadLegends || props.data.length) ? (
                <div className="portfolio-placeholder">
                    <img src="/images/portfolio-placeholder-icon.svg" alt="" />
                    <h5>{enUs.dashboard.dbPortfolio.portfolioPlaceholder}</h5>
                </div>
            ) : (
                <Chart
                    width={'380px'}
                    height={'380px'}
                    chartType="PieChart"
                    // loader={<CircularProgress />}
                    data={[['Amc', 'Cost', ''], ...(props.data || [])]}
                    options={pieOptions}
                    style={{ color: 'white', cursor: 'pointer' }}
                    rootProps={{ 'data-testid': '2' }}
                    chartEvents={[
                        {
                            eventName: 'ready',
                            callback: ({ chartWrapper, google }: any) => {
                                // TODO: Find a better way
                                const chart = chartWrapper.getChart();
                                google.visualization.events.addListener(
                                    chart,
                                    'click',
                                    (e: any) => {
                                        const dataIndex = Number(e.targetID.split('#')[1]);
                                        const amcCode = props.data[dataIndex || 0][2];
                                        history.push(`/portal/portfolio-scheme-details/${amcCode}`);
                                    },
                                );
                                setLoad(true);
                            },
                        },
                        {
                            eventName: 'error',
                            callback: () => {
                                // handling errors while loading
                            },
                        },
                    ]}
                />
            )}
            {loadLegends && (
                <div
                    className="pie-chart-legends"
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        fontSize: 12,
                        alignItems: 'baseline',
                        marginTop: 5,
                        fontFamily: 'Montserrat-SemiBold',
                    }}
                >
                    <p style={{ paddingBottom: 15, fontSize: 13 }}>{props.title}</p>
                    {props.data.map(([label = '', value = 1]: any, index: number) => (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                marginBottom: 8,
                            }}
                        >
                            <div
                                className="pie-chart-legend-color"
                                style={{
                                    height: 10,
                                    width: 10,
                                    backgroundColor: DEFAULT_CHART_COLORS[index],
                                    borderRadius: 2,
                                }}
                            ></div>
                            {console.log(label, value, 'pie')}
                            <p style={{ paddingLeft: 7, textAlign: 'left' }} key={label + index}>
                                {label} - {decimalFix((value / Number(totalValue)) * 100, 1)}%
                            </p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
